import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'convertFrequencia'
})
export class ConvertFrequenciaPipe implements PipeTransform {

  transform(value: any): any {
    switch (value) {
      case 1:
        return 'Nunca';
      case 2:
        return 'Às vezes';
      case 3:
        return 'Semanalmente';
      case 4:
        return 'Todos os dias';
      default:
        return 'index: ' + value;
    }
  }
}
